import { NavLink } from 'react-router-dom';

function Navigation() {
  return (
    <nav className="design-menu" aria-label="Primary">
      <NavLink
        to="/services"
        className={({ isActive }) => `design-menu-link font-bold${isActive ? ' is-active' : ''}`}
      >
        Services
      </NavLink>
      <NavLink
        to="/about"
        className={({ isActive }) => `design-menu-link font-bold${isActive ? ' is-active' : ''}`}
      >
        About
      </NavLink>
      <NavLink
        to="/contact"
        className={({ isActive }) => `design-menu-link font-bold${isActive ? ' is-active' : ''}`}
      >
        Contact
      </NavLink>
    </nav>
  );
}

export default Navigation;